import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { financialCyclesService } from '../services/apiServices';
import { FinancialCycle } from '../types';

// Get all financial cycles
export const useFinancialCycles = () => {
  return useQuery<FinancialCycle[]>({
    queryKey: ['financialCycles'],
    queryFn: () => financialCyclesService.getAll(),
  });
};

// Get current financial cycle
export const useCurrentFinancialCycle = () => {
  return useQuery<FinancialCycle>({
    queryKey: ['currentFinancialCycle'],
    queryFn: () => financialCyclesService.getCurrent(),
  });
};

// Get financial cycle summary
export const useFinancialCycleSummary = () => {
  return useQuery({
    queryKey: ['financialCycleSummary'],
    queryFn: () => financialCyclesService.getSummary(),
  });
};

// Get financial cycle trends
export const useFinancialCycleTrends = () => {
  return useQuery({
    queryKey: ['financialCycleTrends'],
    queryFn: () => financialCyclesService.getTrends(),
  });
};

// Close financial cycle mutation
export const useCloseFinancialCycle = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => financialCyclesService.close(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['financialCycles'] });
      queryClient.invalidateQueries({ queryKey: ['currentFinancialCycle'] });
      queryClient.invalidateQueries({ queryKey: ['financialCycleSummary'] });
      queryClient.invalidateQueries({ queryKey: ['financialCycleTrends'] });
    },
  });
};
